import ContentText from './ContentText';
export default ContentText;
